import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'article-ai-recommendations',
  templateUrl: './ai-recommendations.component.html',
  styleUrls: ['styles.css'],
})
export class AiRecommendationsComponent {
}
